module.exports = __webpack_public_path__ + "static/design05-1807afd9fa0ba931f0a65ce0be416559.jpg";